import React from 'react';
import PublicLayout from 'layout/PublicLayout.js';
// import VehiculoSii from './VehiculoSii.js'
import Contribuyente, { TELEFONO_OBLIGATORIO } from './Contribuyente.js';

import { authenticationService } from 'auth/authenticationService.js'
import { Link, withRouter } from 'react-router-dom';
import TagManager from 'react-gtm-module'


import ReCAPTCHA from 'react-google-recaptcha'


// import withRouter  from 'adds/router/withRouter.js';

import {
  Box,
  Typography,
  Button,
  Alert,
  Chip,
  Grid,
  Card, CardContent,
  Switch, FormControlLabel,
  TextField,
  CircularProgress,
  Input,
  FormControl, FormLabel, RadioGroup, Radio,
  Table, TableHead, TableBody, TableRow, TableCell, TableContainer,
  Collapse, IconButton, TablePagination,

} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import NumberFormat from 'react-number-format';

import DownloadIcon from '@mui/icons-material/Download';
import SearchIcon from '@mui/icons-material/Search';

import DoneIcon from '@mui/icons-material/Done';
import WarningIcon from '@mui/icons-material/Warning';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import CachedIcon from '@mui/icons-material/Cached';



const MULTAS_POR_PAGINA = 20;

class PermisoPublico extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // Filas de multas desplegadas (acordeón), por multa_en_permiso_uuid
      multas_abiertas: {},
      // Página actual de la tabla de multas (20 por página)
      multas_pagina: 0,

      recaptchaRef: null,
      recaptchaResponse: null,
      captcha: null,
      captcha_box: false,

      html: {
        error_prt: null,
        form: true,
        is_new: false,
        tidio_chat: false
      },
      data: null,
      vehiculo: null,
      feedback: {
        patente: '',
        email: '',
        search: '',
        categoria_tipo: '',
      },
      error: {
      },
      status: {
        patente: true,
        email: true,
        search: true,
        form: true,
        categoria_tipo: true
      },
      filters: {
        patente: '',
        email: '',
        categoria_tipo: ''
      },
      dialog_sii: {
        open: false,
      },
      searchloading: false
    };


    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.toBase64 = this.toBase64.bind(this);
    this.handleDownloadFile = this.handleDownloadFile.bind(this);
    this.handleFile = this.handleFile.bind(this);
    this.handleMultaFile = this.handleMultaFile.bind(this);
    this.handleSwitchChange = this.handleSwitchChange.bind(this);

    this.handleBloquear = this.handleBloquear.bind(this);
    this.addHoursToDate = this.addHoursToDate.bind(this);

    this.updateTidio = this.updateTidio.bind(this);
    this.buscarNuevo = this.buscarNuevo.bind(this);

    this.handleCaptcha = this.handleCaptcha.bind(this);
    this.faltanDatosContribuyente = this.faltanDatosContribuyente.bind(this);

    Date.prototype.addHours = function (h) {
      this.setTime(this.getTime() + (h * 60 * 60 * 1000));
      return this;
    }

    // var something = (function () {
    //   let js = document.createElement('script');
    //   js.type = 'text/javascript';
    //   js.async = 1;
    //   js.src = 'https://go.botmaker.com/rest/webchat/p/7GUFGZMEKZ/init.js';
    //   document.body.appendChild(js);
    // })();


  }

  componentDidMount() {
    // console.log(this.props)
    if ('permiso_uuid' in this.props.match.params && this.props.match.params.permiso_uuid !== '') {
      let params = { permiso_uuid: this.props.match.params.permiso_uuid }
      this.handleSubmit(null, params)
    }
    else {
      this.setState({ captcha_box: true, recaptchaRef: React.createRef() })
    }
    // if(!this.state.html.tidio_chat){

    //   this.setState(prevState => ({
    //     html: {...prevState.html,
    //       tidio_chat: true
    //   }}),()=>{
    //     var tidioScript = document.createElement('script');
    //     tidioScript.src = '//code.tidio.co/li7vmk3foxadfqck6lntrufaqtcimhdr.js';
    //     document.body.appendChild(tidioScript);
    //   });

    // }

    // bmShow()

    if (!this.state.html.tidio_chat) {
      this.setState(prevState => ({
        html: {
          ...prevState.html,
          tidio_chat: true
        }
      }), () => {
        let js = document.createElement('script');
        js.type = 'text/javascript';
        js.async = 1;
        js.src = 'https://go.botmaker.com/rest/webchat/p/7GUFGZMEKZ/init.js';
        document.body.appendChild(js);
        console.log(window);
        setTimeout(() => {
          if ('bmShow' in window) {
            window.bmShow()
          }
        }, 5000);

        TagManager.dataLayer({
          dataLayer: {
            event: 'permisos_inicio',
            pagePath: 'permisosweb.renca.cl/',
            pageTitle: 'PermisosWeb - Inicio permiso',
          },
        });


      });

    }


  }
  componentDidUpdate() {
    // console.log(1)

  }

  handleFilterChange(event) {
    const { filters } = { ...this.state };
    const currentState = filters;
    const { name, value } = event.target;


    if (name === 'email') {
      if (value !== '' && /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
        this.setState(prevState => ({
          feedback: {
            ...prevState.feedback,
            email: ''
          },
          status: {
            ...prevState.status,
            email: true
          }
        }));

      }
      else {
        this.setState(prevState => ({
          feedback: {
            ...prevState.feedback,
            email: 'Email con formato incorrecto'
          },
          status: {
            ...prevState.status,
            email: false
          }
        }));
      }

      currentState[name] = value.toLowerCase();
    }
    if (name === 'patente') {
      if (value !== '' && /^[a-zA-Z]{4}[0-9]{2}$|^[a-zA-Z]{2}[0-9]{4}$|^[a-zA-Z]{3}[0-9]{3}$/.test(value)) {
        this.setState(prevState => ({
          feedback: {
            ...prevState.feedback,
            patente: ''
          },
          status: {
            ...prevState.status,
            patente: true
          }
        }));

      }
      else {
        this.setState(prevState => ({
          feedback: {
            ...prevState.feedback,
            patente: 'Debes ingresar una patente válida (Ejemplo:AAAA11, AA1111 o AAA111)'
          },
          status: {
            ...prevState.status,
            patente: false
          }
        }));
      }

      currentState[name] = value.toUpperCase();
    }
    if (name === 'categoria_tipo') {
      if (value in ['1', '2', '3']) {
        this.setState(prevState => ({
          feedback: {
            ...prevState.feedback,
            categoria_tipo: ''
          },
          status: {
            ...prevState.status,
            categoria_tipo: true
          }
        }));

      }
      else {
        this.setState(prevState => ({
          feedback: {
            ...prevState.feedback,
            categoria_tipo: 'Debes seleccionar un tipo de vehiculo'
          },
          status: {
            ...prevState.status,
            categoria_tipo: false
          }
        }));
      }

      currentState[name] = value.toUpperCase();
    }
    this.setState({ filters: currentState });
  }

  toBase64(file) {
    return (
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      })
    )
  }



  handleDownloadFile(event, file_url) {
    event.preventDefault();
    // console.log(file_url)
    var fetch_params = {
      url: '/permisos/uploads/',
      method: 'POST',
      body: JSON.stringify({ relative_path: file_url }),
      ContentType: 'file'
    }

    let file_name_array = file_url.split('/')
    let file_name = file_name_array[file_name_array.length - 1]
    // console.log(file_name)
    authenticationService.fetchPublic(fetch_params)
      .then(result => {

        result.blob().then(blob => {
          // console.log(blob);
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement("a");


          a.href = url;
          a.download = file_name;
          a.click();
        });
      })
      .catch(err => {

      });
  }

  handleSwitchChange(event) {
    const { data } = { ...this.state };
    const currentState = data;
    const { name, checked } = event.target;
    // console.log(name);
    currentState[name] = checked;

    this.setState({ data: currentState }, () => {
      this.handleSubmit(null, { 'field': name, [name]: checked });
    });
  }

  handleFile(event) {
    const { name, files } = event.target
    const file = files[0];

    console.log('tipo: ', file.type);


    if (file.type !== undefined && ['application/pdf', 'image/jpeg', 'image/png', 'image/gif'].includes(file.type)) {
      console.log('paso1');
      this.toBase64(file).then(encodedFile => {
        this.setState(prevState => ({
          data: {
            ...prevState.data,
            [name]: encodedFile
          }
        }), () => {
          console.log('paso2');
          this.handleSubmit(null, { 'field': name, [name]: encodedFile });
        });
      });

      this.setState(prevState => ({
        error: {
          ...prevState,
          [name]: false
        }
      }));
    }
    else {
      this.setState(prevState => ({
        error: {
          ...prevState,
          [name]: true
        }
      }));
    }
  }

  handleMultaFile(event, index) {
    // console.log(event.target)
    const { name, id, files } = event.target
    const file = files[0];

    let params = {
      'field': name,
      'multa_en_permiso_uuid': id,
    }
    if (file.type !== undefined && ['application/pdf', 'image/jpeg', 'image/png', 'image/gif'].includes(file.type)) {
      this.toBase64(file).then(encodedFile => {
        params[name] = encodedFile
        this.handleSubmit(null, params);
      });

      this.setState(prevState => ({
        error: {
          ...prevState,
          [name + '_' + id]: false
        }
      }));
    }
    else {
      //
      this.setState(prevState => ({
        error: {
          ...prevState,
          [name + '_' + id]: true
        }
      }));
    }
  }

  handleSwitchMultaChange(event, index) {
    const { data } = { ...this.state };
    const currentState = data;
    const { id, name, checked } = event.target;


    currentState['multas'][index][name] = checked;


    let params = {
      'field': name,
      'multa_en_permiso_uuid': id,
      [name]: checked
    }

    this.setState({ data: currentState }, () => {
      this.handleSubmit(null, params);
    });
  }
  handleSwitchMultaChange2(event, index) {
    const { data } = { ...this.state };
    const currentState = data;
    const { id, name, value } = event.target;
    console.log(id);
    console.log(event.target);

    let params = {
      'field': name,
      'multa_en_permiso_uuid': id,
      [name]: value == "true" ? true : false,
    }
    // Al indicar que ya la pagó se despliega su detalle (comprobante)
    this.setState(prevState => ({
      data: currentState,
      multas_abiertas: { ...prevState.multas_abiertas, [id]: params[name] }
    }), () => {
      this.handleSubmit(null, params);
    });
  }

  handleBloquear(event, index) {


    let params = {
      field: 'bloqueado',
      bloqueado: true,
      solicitar_revision: true
    }
    this.handleSubmit(null, params);
  }
  addHoursToDate(date, hours) {
    return new Date(new Date(date).setHours(date.getHours() + hours));
  }

  // El contribuyente debe tener sus datos obligatorios antes de continuar con el formulario
  faltanDatosContribuyente() {
    return this.state.data !== null &&
      !this.state.data.datos_contribuyente_status &&
      ![4, 5, 6].includes(this.state.data.estado_consolidado);
  }

  handleCaptcha(key) {
    this.setState({
      captcha: true,
      recaptchaResponse: key
    })
  }

  handleSubmit(event, params = {}) {
    return new Promise((resolve, reject) => {
      this.setState({ searchloading: true });
      if (event) {
        event.preventDefault();
      }
      let ok = false
      /* 
        Caso en parametros
       */
      if ('permiso_uuid' in params) {
        ok = true;
      }
      else if (this.state.data && this.state.data.permiso_uuid && this.state.data.permiso_uuid != '') {
        params.permiso_uuid = this.state.data.permiso_uuid;
        ok = true;
      }
      else if (this.state.filters.patente && this.state.filters.patente !== '' &&
        this.state.filters.email && this.state.filters.email !== '' &&
        this.state.captcha
      ) {
        if (this.state.status.patente && this.state.status.email) {

          params.patente = this.state.filters.patente;
          params.email = this.state.filters.email;
          params.dot = true;
          params.recaptchaResponse = this.state.recaptchaResponse

          if (this.state.html.is_new && this.state.status.categoria_tipo) {
            params.categoria_tipo = true;
          }
          ok = true
        }
        else {
          ok = false
        }
      }



      // console.log('SUBMIT', ok);
      if (ok) {

        // console.log('SUBMIT_PARAMS');
        // console.log(data)
        authenticationService.fetchPublic({
          url: '/permisos/permiso/',
          method: 'POST',
          body: JSON.stringify(params),
          no_error_popup: true
        })
          .then((result) => {
            if ('is_new' in result) {
              this.state.recaptchaRef.current.reset();
              this.setState(prevState => ({
                html: {
                  ...prevState.html,
                  is_new: true,
                },
                captcha: null,
                searchloading: false,
              }), () => {
                this.props.history.push('/');
                // this.updateTidio();
                return resolve(true)
              })
            }
            else {
              let tag_event;
              if ('field' in params) {
                tag_event = 'permisos_upload';
              }
              else {
                tag_event = 'permisos_consulta';
              }
              TagManager.dataLayer({
                dataLayer: {
                  event: tag_event,
                  pagePath: 'permisosweb.renca.cl/',
                  pageTitle: 'PermisosWeb - Consulta permiso',
                },
              });
              this.setState(prevState => ({
                captcha_box: false,
                recaptchaRef: null,
                feedback: {
                  ...prevState.feedback,
                  search: '',
                  update: ''
                },
                status: {
                  ...prevState.status,
                  search: true
                },
                data: result,
                filters: {
                  email: result.contribuyente.email,
                  patente: result.vehiculo.patente
                },
                html: {
                  ...prevState.html,
                  form: false
                },
                searchloading: false
              }), () => {
                this.props.history.push('/');
                // this.updateTidio();
                return resolve(true)
              });
            }

          })
          .catch(error => {
            console.log(error)
            let feedback = '';
            if (error.error === "MAIL_PATENTE_INCORRECTO") {

              feedback = `Esta patente no está asociada al mail ingresado.\n
                        Intenta con otro mail o contáctanos directo al chat.`
            }
            else if (error.error === "UUID_INCORRECTO") {
              feedback = `La url con las que estás accediendo está incorrecta. Ingresa una patente y email.`
            }
            else if (error.error === "WRONGCAPTCHA") {
              feedback = `Captcha incorrecto. Si estás haciendo trampa, debes saber que todo el llamado está siendo registrado.`
            }
            else if (error.error === "NOCAPTCHA") {
              feedback = `Captcha incorrecto.`
            }
            else if (error.error === "CONTRIBUYENTE_INCOMPLETO") {
              feedback = `Debes completar correctamente los datos obligatorios del contribuyente (nombre, apellido paterno, rut, email${TELEFONO_OBLIGATORIO ? ' y teléfono' : ''}) antes de continuar.`
            }
            else {
              feedback = error.error;
            }
            // Caso actualización de un permiso ya cargado: se mantiene el formulario y se muestra el error
            if (this.state.data && 'field' in params) {
              this.setState(prevState => ({
                feedback: {
                  ...prevState.feedback,
                  update: feedback
                },
                searchloading: false,
              }));
              return resolve(false)
            }
            this.setState(prevState => ({
              feedback: {
                ...prevState.feedback,
                search: feedback
              },
              status: {
                ...prevState.status,
                search: false
              },
              data: null,
              vehiculo: null,
              searchloading: false,
            }));
            return resolve(false)
          });
      }
      else {
        this.setState(prevState => ({
          feedback: {
            ...prevState.feedback,
            search: "Debes ingresar una patente y email válidos, además de hacer click en el Captcha"
          },
          status: {
            ...prevState.status,
            search: false
          },
          searchloading: false,
        }));
      }
    });
  }
  updateTidio() {
    setTimeout(() => {
      if (window.tidioChatApi) {
        if (this.state.filters.email && this.state.filters.email !== '' && this.state.filters.patente && this.state.filters.patente !== '') {
          window.tidioChatApi.setVisitorData({
            email: this.state.filters.email,
          });
          window.tidioChatApi.setContactProperties({
            patente: this.state.filters.patente,
          });
        }
      }
    }, 1000);
  }
  buscarNuevo() {
    this.setState(prevState => ({
      html: {
        ...prevState.html,
        is_new: false,
        form: true,
        recaptchaRef: React.createRef()
      }
    }), () => {
      this.setState({ captcha_box: true })
      this.setState({ data: null, captcha: null });
    });
  }

  // Página de multas válida para la cantidad actual (por si cambia el permiso o sus multas)
  paginaMultas() {
    const total = this.state.data && this.state.data.multas ? this.state.data.multas.length : 0;
    const ultima = Math.max(0, Math.ceil(total / MULTAS_POR_PAGINA) - 1);
    return Math.min(this.state.multas_pagina, ultima);
  }

  render() {
    return (

      <PublicLayout>



        <Box>
          {this.state.html.form &&
            <>
              {/* <Box>
                <Alert severity='info'>
                  <Box>
                    <Typography variant="caption">
                      Si estás solo renovando el permiso, y ya tienes todos tus papeles en órden, trata de ingresar directamente al pago.
                      <br />
                      Si tienes consultas, también nos puedes escribir en el chat de abajo a la derecha.
                    </Typography>
                  </Box>
                  <Box textAlign="center" p={1}>
                    <Button variant='contained'
                      color='primary'
                      component={Link}
                      to={{ pathname: 'http://pago.smc.cl/pagoPCVv2/muni/renca.aspx' }} target="_blank">
                      Paga Aquí
                    </Button>
                  </Box>

                  <Box>

                  </Box>
                </Alert>
              </Box> */}
              <Box p={1} mt={3}>
                <Typography variant="h6">
                  {/* Para renovar o sacar un nuevo permiso de circulación */}
                  Traslada tu permiso a Renca ¡Es fácil y rápido!
                  <br />

                </Typography>
                Si nunca has pagado tu permiso de circulación en Renca, utiliza esta sección para solicitar el traslado.
              </Box>
              <Box p={1}>
                <TextField name='patente'
                  id='patente'
                  label='Patente del vehículo'
                  placeholder='Patente del vehículo'
                  fullWidth
                  maxLength='10'
                  value={this.state.filters.patente}
                  onChange={this.handleFilterChange}
                  helperText={this.state.feedback.patente}
                  error={!this.state.status.patente}
                  variant="standard"
                />
              </Box>
              <Box p={1}>
                <TextField name='email'
                  id='email'
                  label='Email de contacto'
                  placeholder='Email de contacto'
                  fullWidth
                  maxLength='300'
                  value={this.state.filters.email}
                  onChange={this.handleFilterChange}
                  helperText={this.state.feedback.email}
                  error={!this.state.status.email}
                  variant="standard"
                />
              </Box>
              {this.state.captcha_box &&
                <Box p={1}>
                  <ReCAPTCHA onChange={this.handleCaptcha}
                    ref={this.state.recaptchaRef}
                    //This ref can be used to call captcha related functions in case you need.
                    sitekey="6LcqiW0pAAAAAN1aad8yGpkTMXIh7OEd12R9ZWdi"
                  />
                </Box>
              }
              {this.state.html.is_new &&
                <Box p={1}>
                  <FormControl>
                    <FormLabel id="demo-radio-buttons-group-label">Ingresa también por favor el tipo de de vehículo</FormLabel>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      name="categoria_tipo"
                      value={this.state.filters.categoria_tipo}
                      onChange={this.handleFilterChange}
                    >
                      <FormControlLabel value="1" control={<Radio />} label="Vehículo liviano" />
                      <FormControlLabel value="2" control={<Radio />} label="Locomoción colectiva" />
                      <FormControlLabel value="3" control={<Radio />} label="Vehículo pesado" />
                    </RadioGroup>
                  </FormControl>
                </Box>
              }
              <Box mt={2} mb={15} textAlign='left'>
                <Button onClick={(event) => this.handleSubmit(event)}
                  variant="contained"
                  startIcon={this.state.searchloading ? <CircularProgress size={20} /> : <SearchIcon />}
                  disabled={this.state.searchloading ? true : false}
                >
                  Ingresar o Buscar Patente
                </Button>
              </Box>
              {!this.state.status.search &&
                <Box p={1}>
                  <Alert severity='error'>
                    {this.state.feedback.search}
                  </Alert>
                </Box>
              }
            </>
          }
          {this.state.data &&
            <Box>

              <Box p={1}>
                <Typography variant="h6">
                  Renovación, traslado u obtención de permiso de circulación
                </Typography>
              </Box>

              <Box p={2} textAlign="right">
                <Button onClick={(event) => this.buscarNuevo(event)}
                  startIcon={this.state.searchloading ? <CircularProgress size={20} /> : <SearchIcon />}
                  variant="outlined"
                >
                  Buscar una nueva patente
                </Button>
              </Box>

              <Box p={1} mb={2} sx={{
                borderRadius: '5px',
                boxShadow: "0.3em 0.3em 1em rgba(0, 0, 0, 0.3)"
              }}>
                <Box p={1}>
                  <Grid container>
                    <Grid item xs={6}>
                      <Box>
                        <Typography variant='h6'>
                          Patente
                        </Typography>

                        <Typography variant='body2' color='textSecondary'>
                          {this.state.data?.vehiculo?.patente}
                        </Typography>
                      </Box>
                      <Box>
                        <Typography variant='h6'>
                          Mail contribuyente
                        </Typography>

                        <Typography variant='body2' color='textSecondary'>
                          {this.state.data?.contribuyente?.email}
                        </Typography>
                      </Box>

                    </Grid>
                    <Grid item xs={6}>
                      <Box>
                        <Typography variant='h6'>
                          Tipo de Vehículo
                        </Typography>
                        <Typography variant='body2' color='textSecondary'>
                          {this.state.data?.vehiculo?.categoria_tipo === 1 ? "Vehiculo liviano" :
                            this.state.data?.vehiculo?.categoria_tipo === 3 ? "Vehiculo Pesado" :
                              this.state.data?.vehiculo?.categoria_tipo === 2 ? "Locomoción colectiva" :
                                "Hay un error con el vehículo. Por favor contáctanos en el chat para corregirlo"
                          }
                        </Typography>
                      </Box>
                      <Box>
                        <Typography variant='h6'>
                          Año del proceso de permiso de circulación
                        </Typography>

                        <Typography variant='body2' color='textSecondary'>
                          {this.state.data?.agno_proceso}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>

                {
                  /*****************************************
                    Estado Consolidado
                  ******************************************/
                }
                <Box p={1} pb={2}>
                  <Box p={0}>
                    <Alert severity={this.state.data.estado_consolidado === 0 ? 'warning' :
                      this.state.data.estado_consolidado === 1 ? 'success' :
                        this.state.data.estado_consolidado === 2 ? 'error' :
                          this.state.data.estado_consolidado === 3 ? 'info' :
                            this.state.data.estado_consolidado === 4 ? 'success' :
                              this.state.data.estado_consolidado === 6 ? 'warning' :
                              'info'}
                      style={{ minHeigth: '100px' }}
                      variant={[4, 5, 6].includes(this.state.data.estado_consolidado) ? 'filled' : 'standard'}>
                      <Typography variant='h6'>
                        Estado del permiso de circulación
                      </Typography>
                      <Box>
                        <strong>Estado consolidado: </strong> {this.state.data.estado}
                      </Box>
                      <Box>
                        <strong>Comentario al contribuyente</strong>: {this.state.data.comentario_consolidado}
                      </Box>
                    </Alert>
                  </Box>
                  <Box>
                    {[1, 6].includes(this.state.data.estado_consolidado) &&
                      <Box p={3}>
                        <Button variant='contained'
                          color='primary'
                          component={Link}
                          to={{ pathname: 'http://pago.smc.cl/pagoPCVv2/muni/renca.aspx' }} target="_blank">
                          Ir al Pago
                        </Button>
                      </Box>
                    }
                    {this.state.data.estado_consolidado === 0 && !this.state.data.bloqueado && !this.faltanDatosContribuyente() &&
                      <Box p={3}>
                        <Button variant='contained'
                          id='boton_solicitar_revision_1'
                          color='primary'
                          onClick={this.handleBloquear}>
                          Solicitar revisión de los documentos (Esto bloqueará este formulario, todo mientras sea revisado por nuestros agentes.)
                        </Button>
                      </Box>
                    }
                    {/* Para estados de 0 - pendiente, 2 - incompleto, 3 - rechazado */}
                    {this.state.data.bloqueado && [0, 2, 3].includes(this.state.data.estado_consolidado) &&
                      <Box p={3}>
                        <Typography variant='overline'>
                          Tu permiso ahora está siendo validado por nuestros equipos. Te notificaremos por mail cuando todo esté listo.
                        </Typography>
                      </Box>
                    }
                    {/* En los estados 4 - pagado, 5 - descartado; simplemente no se imprime ninguna acción posible. */}

                    {this.state.data.estado_consolidado === 4 &&
                      <Box p={3}>
                        <Button variant='contained'
                          color='primary'
                          component={Link}
                          to={{ pathname: 'http://pago.smc.cl/pagoPCVv2/muni/renca.aspx' }} target="_blank">
                          Rescatar el PDF mi Permiso
                        </Button>
                      </Box>
                    }
                  </Box>
                </Box>

              </Box>


              {this.state.feedback.update &&
                <Box mb={1}>
                  <Alert severity='error'>
                    {this.state.feedback.update}
                  </Alert>
                </Box>
              }

              {this.faltanDatosContribuyente() &&
                <Box mb={1}>
                  <Alert severity='warning' variant='filled'>
                    <Typography variant='h6' sx={{ color: 'inherit' }}>
                      Antes de continuar, completa tus datos personales
                    </Typography>
                    {this.state.data.bloqueado ?
                      <Box>
                        Tu permiso no tiene los datos obligatorios del contribuyente y está bloqueado. Por favor contáctanos por el chat.
                      </Box>
                      :
                      <Box>
                        Para seguir con tu solicitud debes completar y guardar los datos obligatorios del contribuyente:
                        nombre, apellido paterno (o nombre de la empresa), rut, email{TELEFONO_OBLIGATORIO ? ' y teléfono' : ''}.
                        Una vez guardados, aparecerá el resto del formulario.
                      </Box>
                    }
                  </Alert>
                </Box>
              }

              {
                /*****************************************
                  Contribuyente
                 ******************************************/
              }
              <Box mb={1}>
                <Card>
                  <CardContent>
                    <Box>
                      <Alert severity={this.state.data.estado_contribuyente === 0 ? 'warning' :
                        this.state.data.estado_contribuyente === 1 ? 'success' :
                          this.state.data.estado_contribuyente === 2 ? 'error' :
                            this.state.data.estado_contribuyente === 3 ? 'info' :
                              'info'}
                        style={{ minHeigth: '100px' }}>
                        <Typography variant='h6'>
                          Contribuyente asociado al Vehículo
                        </Typography>
                        <Box>
                          {this.state.data.estado_contribuyente === 0 ? <Box><strong>Estado sección: </strong> {' Pendiente a validación del Departamento de Tránsito Municipal.'}</Box> :
                            this.state.data.estado_contribuyente === 1 ? <Box><strong>Estado sección: </strong> {' Todo en órden.'}</Box> :
                              this.state.data.estado_contribuyente === 2 ? <Box><strong>Estado sección: </strong> {' Información rechazada.'}</Box> :
                                this.state.data.estado_contribuyente === 3 ? <Box><strong>Estado sección: </strong> {' Información aún incompleta.'}</Box> :
                                  'info'}
                        </Box>
                        <Box>
                          <strong>Comentario</strong>: {this.state.data.comentario_contribuyente}
                        </Box>

                      </Alert>
                    </Box>

                    {this.state.data &&
                      <Box>
                        <Contribuyente contribuyente={this.state.data.contribuyente}
                          permiso={this.state.data}
                          updatePermiso={this.handleSubmit}
                          forzarFormulario={this.faltanDatosContribuyente() && !this.state.data.bloqueado} />
                      </Box>
                    }
                  </CardContent>
                </Card>
              </Box>


              {!this.faltanDatosContribuyente() &&
              <>
              {
                /*****************************************
                 IDENTIFACION DEL AUTOMOVIL
                ******************************************/
              }
              <Box mb={1}>
                <Card>
                  <CardContent>
                    <Box p={1}>
                      <Alert severity={this.state.data.estado_identificacion === 0 ? 'warning' :
                        this.state.data.estado_identificacion === 1 ? 'success' :
                          this.state.data.estado_identificacion === 2 ? 'error' :
                            this.state.data.estado_identificacion === 3 ? 'info' :
                              'info'}
                        style={{ minHeigth: '100px' }}>
                        <Typography variant='h6'>
                          Identificación del vehículo
                        </Typography>
                        <Box>
                          {this.state.data.estado_identificacion === 0 ? <Box><strong>Estado sección: </strong> {' Pendiente a validación del Departamento de Tránsito Municipal.'}</Box> :
                            this.state.data.estado_identificacion === 1 ? <Box><strong>Estado sección: </strong> {' Todo en órden.'}</Box> :
                              this.state.data.estado_identificacion === 2 ? <Box><strong>Estado sección: </strong> {' Información rechazada.'}</Box> :
                                this.state.data.estado_identificacion === 3 ? <Box><strong>Estado sección: </strong> {' Información aún incompleta.'}</Box> :
                                  'info'}
                        </Box>
                        <Box>
                          <strong>Comentario</strong>: {this.state.data.comentario_identificacion}
                        </Box>
                      </Alert>
                    </Box>


                    <Box p={1}>
                      <Typography variant='overline' sx={{ fontWeight: 'bold' }}>
                        ¿Es renovación de la misma comuna (permiso del año anterior es de Renca)?
                      </Typography>
                      <Box pl={2} sx={{ display: 'inline' }}>
                        <Chip size="small"
                          label={this.state.data.renovacion_status ? 'Si' : 'No'}
                          icon={(this.state.data.renovacion_status) ? <DoneIcon /> : <WarningIcon />}
                          style={(this.state.data.renovacion_status) ? { backgroundColor: 'lightgreen' } : {}}
                        />

                      </Box>
                      {this.state.data.tipo === 'Renovación' &&
                        <Box>
                          <Typography variant='body2'>
                            Este vehículo es una renovación (el permiso del año pasado es de Renca). Por lo tanto, no es necesario que agregues documentos como el padrón o permiso anterior.
                          </Typography>
                        </Box>
                      }
                      {this.state.data.tipo !== 'Renovación' &&

                        <Box>
                          <Typography variant='body2'>
                            Este vehículo no es una renovación del año pasado (permiso anterior no es de Renca),
                            por lo cual es necesario adjuntar los documentos de padrón y permiso de circulación anterior.
                          </Typography>
                        </Box>
                      }
                    </Box>

                    {(this.state.data.tipo !== 'Renovación' || this.state.data.identificacion_exigir_documentos) &&
                      <Grid container spacing={1}>
                        <Grid item md={6} sm={12}>
                          <Box p={1} style={{ borderRadius: '5px', border: '2px solid #ddd', }}>
                            <Typography variant='overline' sx={{ fontWeight: 'bold' }}>
                              Padrón del vehículo
                            </Typography>
                            <Box pl={2} sx={{ display: 'inline' }}>
                              <Chip size="small"
                                label={this.state.data.archivo_padron_status ? 'Completo' : 'Incompleto'}
                                icon={(this.state.data.archivo_padron_status) ? <DoneIcon /> : <WarningIcon />}
                                style={(this.state.data.archivo_padron_status) ? { backgroundColor: 'lightgreen' } : {}}
                              />

                            </Box>

                            {this.state.data.archivo_padron &&
                              <Box p={1} style={{ background: '#eeeeff', borderRadius: '5px' }}>
                                <Typography variant='overline'>
                                  Actualmente ya tienes un archivo de padrón cargado&nbsp;
                                </Typography>
                                <Button variant='contained' startIcon={<DownloadIcon />} onClick={event => this.handleDownloadFile(event, this.state.data.archivo_padron)}>
                                  Descargar
                                </Button>
                              </Box>
                            }
                            {[0, 2, 3].includes(this.state.data.estado_identificacion) && !this.state.data.bloqueado &&
                              <Box p={1} mt={1} style={{ background: '#e1e1ff', borderRadius: '5px' }}>
                                <Typography variant='overline'>
                                  Subir/Actualizar (Archivo PDF o imagen):&nbsp;
                                </Typography>
                                <Box>
                                  <label htmlFor="encodedPadronFile">
                                    <Input name="encodedPadronFile"
                                      id="encodedPadronFile"
                                      type="file"
                                      accept="image/*,.pdf"
                                      onChange={this.handleFile}
                                      style={{ display: 'none' }}
                                    />
                                    {'encodedPadronFile' in this.state.error && this.state.error.encodedPadronFile &&
                                      <Box sx={{ color: 'red' }}>El archivo debe ser un PDF o imágen</Box>

                                    }
                                    <Button startIcon={<UploadFileIcon />} variant='outlined' component="span">
                                      {this.state.data.encodedPadronFile !== '' && this.state.data.encodedPadronFile !== null ? 'Actualizar archivo' : 'Subir archivo'}
                                    </Button>
                                  </label>
                                </Box>
                              </Box>
                            }
                          </Box>
                        </Grid>
                        <Grid item md={6} sm={12}>
                          <Box p={1} style={{ borderRadius: '5px', border: '2px solid #ddd', }}>
                            <Typography variant='overline' sx={{ fontWeight: 'bold' }}>
                              Permiso de ciculación anterior
                            </Typography>
                            <Box pl={2} sx={{ display: 'inline' }}>
                              <Chip size="small"
                                label={this.state.data.archivo_permiso_anterior_status ? 'Completo' : 'Incompleto'}
                                icon={(this.state.data.archivo_permiso_anterior_status) ? <DoneIcon /> : <WarningIcon />}
                                style={(this.state.data.archivo_permiso_anterior_status) ? { backgroundColor: 'lightgreen' } : {}}
                              />

                            </Box>
                            {this.state.data.archivo_permiso_anterior &&
                              <Box p={1} style={{ background: '#eeeeff', borderRadius: '5px' }}>
                                <Typography variant='overline'>
                                  Actualmente ya tienes un archivo de permiso anterior cargado&nbsp;
                                </Typography>
                                <Button variant='contained' startIcon={<DownloadIcon />} onClick={event => this.handleDownloadFile(event, this.state.data.archivo_permiso_anterior)}>
                                  Descargar
                                </Button>
                              </Box>
                            }
                            {[0, 2, 3].includes(this.state.data.estado_identificacion) && !this.state.data.bloqueado &&
                              <Box p={1} mt={1} style={{ background: '#e1e1ff', borderRadius: '5px' }}>
                                <Typography variant='overline'>
                                  Subir/Actualizar:&nbsp;
                                </Typography>
                                <Box>
                                  <label htmlFor="encodedPermisoAnteriorFile">
                                    <Input name="encodedPermisoAnteriorFile"
                                      id="encodedPermisoAnteriorFile"
                                      type="file"
                                      accept="image/*,.pdf"
                                      onChange={this.handleFile}
                                      style={{ display: 'none' }}
                                    />
                                    {'encodedPermisoAnteriorFile' in this.state.error && this.state.error.encodedPermisoAnteriorFile &&
                                      <Box sx={{ color: 'red' }}>El archivo debe ser un PDF o imágen</Box>
                                    }
                                    <Button startIcon={<UploadFileIcon />} variant='outlined' component="span">
                                      {this.state.data.encodedPermisoAnteriorFile !== '' && this.state.data.encodedPermisoAnteriorFile !== null ? 'Actualizar archivo' : 'Subir archivo'}
                                    </Button>
                                  </label>
                                </Box>
                              </Box>
                            }

                          </Box>
                        </Grid>
                      </Grid>
                    }

                  </CardContent>
                </Card>
              </Box>

              {
                /*****************************************
                  Tasacion SII
                  ******************************************/
              }
              <Box mb={1}>
                <Card>
                  <CardContent>
                    <Box p={1}>
                      <Alert severity={this.state.data.estado_sii === 0 ? 'warning' :
                        this.state.data.estado_sii === 1 ? 'success' :
                          this.state.data.estado_sii === 2 ? 'error' :
                            this.state.data.estado_sii === 3 ? 'info' :
                              'info'}
                        style={{ minHeigth: '100px' }}>
                        <Typography variant='h6'>
                          Tasación SII
                        </Typography>

                        <Box>
                          {this.state.data.estado_sii === 0 ? <Box><strong>Estado sección: </strong> {' Pendiente a validación del Departamento de Tránsito Municipal.'}</Box> :
                            this.state.data.estado_sii === 1 ? <Box><strong>Estado sección: </strong> {' Todo en órden.'}</Box> :
                              this.state.data.estado_sii === 2 ? <Box><strong>Estado sección: </strong> {' Información rechazada.'}</Box> :
                                this.state.data.estado_sii === 3 ? <Box><strong>Estado sección: </strong> {' Información aún incompleta.'}</Box> :
                                  'info'}
                        </Box>
                        <Box>
                          <strong>Comentario</strong>: {this.state.data.comentario_sii}
                        </Box>
                      </Alert>
                    </Box>

                    {[0, 2, 3].includes(this.state.data.estado_consolidado) && !this.state.data.bloqueado &&
                      <Box p={1}>
                        <FormControlLabel control={<Switch name='sii_es_nuevo'
                          id='sii_es_nuevo'
                          onChange={this.handleSwitchChange}
                          checked={this.state.data.sii_es_nuevo}
                        />}
                          label="Es un vehículo nuevo (año 2023-2024)" />
                      </Box>
                    }

                    {(this.state.data.sii_es_nuevo || this.state.data.sii_exigir_documentos) &&
                      <Box p={1} style={{ borderRadius: '5px', border: '2px solid #ddd', }}>
                        <Typography variant='overline' sx={{ fontWeight: 'bold' }}>
                          Factura del vehículo
                        </Typography>
                        {this.state.data.archivo_sii &&
                          <Box p={1} style={{ background: '#eeeeff', borderRadius: '5px' }}>
                            <Typography variant='overline'>
                              Actualmente ya tienes un archivo de factura cargado
                            </Typography>
                            <Box>
                              <Button startIcon={<DownloadIcon />}
                                onClick={event => this.handleDownloadFile(event, this.state.data.archivo_sii)}
                                variant='contained'>
                                Descargar archivo
                              </Button>
                            </Box>
                          </Box>
                        }

                        {[0, 2, 3].includes(this.state.data.estado_sii) && !this.state.data.bloqueado &&
                          <Box p={1} mt={1} style={{ background: '#e1e1ff', borderRadius: '5px' }}>
                            <Typography variant='overline'>
                              Subir/Actualizar (Archivo PDF o imagen):&nbsp;
                            </Typography>
                            <Box>
                              <label htmlFor="encodedSiiFile">
                                <Input name="encodedSiiFile"
                                  id="encodedSiiFile"
                                  type="file"
                                  accept="image/*,.pdf"
                                  onChange={this.handleFile}
                                  style={{ display: 'none' }}
                                />
                                {'encodedSiiFile' in this.state.error && this.state.error.encodedSiiFile &&
                                  <Box sx={{ color: 'red' }}>El archivo debe ser un PDF o imágen</Box>
                                }
                                <Button startIcon={<UploadFileIcon />} variant='outlined' component="span">
                                  {this.state.data.encodedSiiFile !== '' && this.state.data.encodedSiiFile !== null ? 'Actualizar archivo' : 'Subir archivo'}
                                </Button>
                              </label>
                            </Box>
                          </Box>
                        }
                      </Box>
                    }
                  </CardContent>
                </Card>
              </Box>

              {
                /*****************************************
                  REVISION TECNICA
                ******************************************/
              }
              <Box mb={1}>
                <Card>
                  <CardContent>
                    <Box p={1}>
                      <Alert severity={this.state.data.estado_prt === 0 ? 'warning' :
                        this.state.data.estado_prt === 1 ? 'success' :
                          this.state.data.estado_prt === 2 ? 'error' :
                            this.state.data.estado_prt === 3 ? 'info' :
                              'info'}
                        style={{ minHeigth: '100px' }}>
                        <Typography variant='h6'>
                          Revisión técnica
                        </Typography>

                        <Box>
                          {this.state.data.estado_prt === 0 ? <Box><strong>Estado sección: </strong> {' Pendiente a validación del Departamento de Tránsito Municipal.'}</Box> :
                            this.state.data.estado_prt === 1 ? <Box><strong>Estado sección: </strong> {' Todo en órden.'}</Box> :
                              this.state.data.estado_prt === 2 ? <Box><strong>Estado sección: </strong> {' Información rechazada.'}</Box> :
                                this.state.data.estado_prt === 3 ? <Box><strong>Estado sección: </strong> {' Información aún incompleta.'}</Box> :
                                  'info'}
                        </Box>
                        <Box>
                          <strong>Comentario al contribuyente</strong>: {this.state.data.comentario_prt}
                        </Box>
                      </Alert>
                    </Box>

                    {this.state.data.webservice_prt_status === false &&
                      [0, 2, 3].includes(this.state.data.estado_prt) && !this.state.data.bloqueado &&
                      this.state.data.prt &&
                      new Date(this.state.data.prt.fecha_consulta) < this.addHoursToDate(new Date(), -1) &&
                      <Box>
                        <Button startIcon={<CachedIcon />}
                          onClick={event => this.handleSubmit(event, { 'reload_prt': true })}
                        >
                          Recargar revisión técnica
                        </Button>
                      </Box>
                    }
                    {/* CASO no es posible validar por webservice */}
                    {(this.state.data.prt_exigir_documentos || this.state.data.webservice_prt_status === false) &&

                      <Box p={1}>
                        {!this.state.data.sii_es_nuevo && [0, 2, 3].includes(this.state.data.estado_prt) && !this.state.data.bloqueado &&
                          <Box p={1}>
                            <FormControlLabel control={<Switch name='prt_es_homologacion'
                              id='prt_es_homologacion'
                              onChange={this.handleSwitchChange}
                              checked={this.state.data.prt_es_homologacion}
                            />}
                              label="Este vehículo tiene homologación" />
                          </Box>
                        }
                        {!this.state.data.sii_es_nuevo && !this.state.data.prt_es_homologacion &&
                          <Box>
                            <Box p={1} style={{ borderRadius: '5px', border: '2px solid #ddd', }}>
                              <Typography variant='overline' sx={{ fontWeight: 'bold' }}>
                                Comprobante de Revisión técnica
                              </Typography>
                              <Box pl={2} sx={{ display: 'inline' }}>
                                <Chip size="small"
                                  label={this.state.data.archivo_revision_status ? 'Completo' : 'Incompleto'}
                                  icon={(this.state.data.archivo_revision_status) ? <DoneIcon /> : <WarningIcon />}
                                  style={(this.state.data.archivo_revision_status) ? { backgroundColor: 'lightgreen' } : {}}
                                />
                              </Box>

                              {this.state.data.archivo_revision &&
                                <Box p={1} style={{ background: '#eeeeff', borderRadius: '5px' }}>
                                  <Typography variant='overline'>
                                    Actualmente ya tienes un archivo cargado&nbsp;
                                  </Typography>
                                  <Box>
                                    <Button startIcon={<DownloadIcon />}
                                      onClick={event => this.handleDownloadFile(event, this.state.data.archivo_revision)}
                                      variant='contained'>
                                      Descargar archivo
                                    </Button>
                                  </Box>
                                </Box>
                              }

                              {[0, 2, 3].includes(this.state.data.estado_prt) && !this.state.data.bloqueado &&
                                <Box p={1} mt={1} style={{ background: '#e1e1ff', borderRadius: '5px' }}>
                                  <Typography variant='overline'>
                                    Subir/Actualizar (Archivo PDF o imagen):&nbsp;
                                  </Typography>
                                  <Box>
                                    <label htmlFor="encodedRevisionFile">
                                      <Input name="encodedRevisionFile"
                                        id="encodedRevisionFile"
                                        type="file"
                                        accept="image/*,.pdf"
                                        onChange={this.handleFile}
                                        style={{ display: 'none' }}
                                      />
                                      {'encodedRevisionFile' in this.state.error && this.state.error.encodedRevisionFile &&
                                        <Box sx={{ color: 'red' }}>El archivo debe ser un PDF o imágen</Box>
                                      }
                                      <Button startIcon={<UploadFileIcon />} variant='outlined' component="span">
                                        {this.state.data.encodedRevisionFile !== '' && this.state.data.encodedRevisionFile !== null ? 'Actualizar archivo' : 'Subir archivo'}
                                      </Button>
                                    </label>
                                  </Box>
                                </Box>
                              }

                            </Box>
                            <Box p={1} mt={1} style={{ borderRadius: '5px', border: '2px solid #ddd', }}>
                              <Typography variant='overline' sx={{ fontWeight: 'bold' }}>
                                Comprobante de Gases
                              </Typography>
                              <Box pl={2} sx={{ display: 'inline' }}>
                                <Chip size="small"
                                  label={this.state.data.archivo_gases_status ? 'Completo' : 'Incompleto'}
                                  icon={(this.state.data.archivo_gases_status) ? <DoneIcon /> : <WarningIcon />}
                                  style={(this.state.data.archivo_gases_status) ? { backgroundColor: 'lightgreen' } : {}}
                                />
                              </Box>
                              <Box>
                                {this.state.data.archivo_gases &&
                                  <Box p={1} style={{ background: '#eeeeff', borderRadius: '5px' }}>
                                    <Typography variant='overline'>
                                      Actualmente ya tienes un archivo cargado&nbsp;
                                    </Typography>
                                    <Box>
                                      <Button startIcon={<DownloadIcon />}
                                        onClick={event => this.handleDownloadFile(event, this.state.data.archivo_gases)}
                                        variant='contained'>
                                        Descargar archivo
                                      </Button>
                                    </Box>
                                  </Box>
                                }
                              </Box>

                              {[0, 2, 3].includes(this.state.data.estado_prt) && !this.state.data.bloqueado &&
                                <Box p={1} mt={1} style={{ background: '#e1e1ff', borderRadius: '5px' }}>
                                  <Typography variant='overline'>
                                    Subir/Actualizar (Archivo PDF o imagen):&nbsp;
                                  </Typography>
                                  <Box>
                                    <label htmlFor="encodedGasesFile">
                                      <Input name="encodedGasesFile"
                                        id="encodedGasesFile"
                                        type="file"
                                        accept="image/*,.pdf"
                                        onChange={this.handleFile}
                                        style={{ display: 'none' }}
                                      />
                                      {'encodedGasesFile' in this.state.error && this.state.error.encodedGasesFile &&
                                        <Box sx={{ color: 'red' }}>El archivo debe ser un PDF o imágen</Box>
                                      }
                                      <Button startIcon={<UploadFileIcon />} variant='outlined' component="span">
                                        {this.state.data.encodedGasesFile !== '' && this.state.data.encodedGasesFile !== null ? 'Actualizar archivo' : 'Subir archivo'}
                                      </Button>
                                    </label>
                                  </Box>
                                </Box>
                              }

                            </Box>
                          </Box>
                        }
                        {(this.state.data.sii_es_nuevo || this.state.data.prt_es_homologacion) &&
                          <Box p={1} style={{ borderRadius: '5px', border: '2px solid #ddd', }}>
                            <Typography variant='overline' sx={{ fontWeight: 'bold' }}>
                              Comprobante de Homologación
                            </Typography>
                            <Box pl={2} sx={{ display: 'inline' }}>
                              <Chip size="small"
                                label={this.state.data.archivo_homologacion_status ? 'Completo' : 'Incompleto'}
                                icon={(this.state.data.archivo_homologacion_status) ? <DoneIcon /> : <WarningIcon />}
                                style={(this.state.data.archivo_homologacion_status) ? { backgroundColor: 'lightgreen' } : {}}
                              />
                            </Box>
                            {this.state.data.archivo_homologacion &&
                              <Box p={1} style={{ background: '#eeeeff', borderRadius: '5px' }}>
                                <Typography variant='overline'>
                                  Actualmente ya tienes un archivo cargado&nbsp;
                                </Typography>
                                <Box>
                                  <Button startIcon={<DownloadIcon />}
                                    onClick={event => this.handleDownloadFile(event, this.state.data.archivo_homologacion)}
                                    variant='contained'>
                                    Descargar archivo
                                  </Button>
                                </Box>
                              </Box>
                            }
                            {[0, 2, 3].includes(this.state.data.estado_prt) && !this.state.data.bloqueado &&
                              <Box p={1} mt={1} style={{ background: '#e1e1ff', borderRadius: '5px' }}>
                                <Typography variant='overline'>
                                  Subir/Actualizar (Archivo PDF o imagen):&nbsp;
                                </Typography>
                                <Box>
                                  <label htmlFor="encodedHomologacionFile">
                                    <Input name="encodedHomologacionFile"
                                      id="encodedHomologacionFile"
                                      type="file"
                                      accept="image/*,.pdf"
                                      onChange={this.handleFile}
                                      style={{ display: 'none' }}
                                    />
                                    {'encodedHomologacionFile' in this.state.error && this.state.error.encodedHomologacionFile &&
                                      <Box sx={{ color: 'red' }}>El archivo debe ser un PDF o imágen</Box>
                                    }
                                    <Button startIcon={<UploadFileIcon />} variant='outlined' component="span">
                                      {this.state.data.encodedHomologacionFile !== '' && this.state.data.encodedHomologacionFile !== null ? 'Actualizar archivo' : 'Subir archivo'}
                                    </Button>
                                  </label>
                                </Box>
                              </Box>
                            }

                          </Box>
                        }

                      </Box>
                    }

                    {/* CASO validación es por Webservice */}
                    {this.state.data.webservice_prt_status &&
                      <Box p={1}>
                        <Box>
                          <Typography variant='overline'>
                            Estado de la revisión técnica en línea
                          </Typography>
                          <Box pl={2} sx={{ display: 'inline' }}>
                            <Chip size="small"
                              label={this.state.data.webservice_prt_status ? 'Revisión técnica validada' : 'No fue posible validar la revisión técnica'}
                              icon={(this.state.data.webservice_prt_status) ? <DoneIcon /> : <WarningIcon />}
                              style={(this.state.data.webservice_prt_status) ? { backgroundColor: 'lightgreen' } : {}}
                            />
                          </Box>
                        </Box>
                        {this.state.data.prt &&
                          <Box>
                            <Box>
                              <Typography variant='caption'>
                                Fecha consulta: &nbsp;
                                {(new Date(this.state.data.prt.fecha_consulta)).toLocaleString('es-CL')}
                              </Typography>
                            </Box>
                            <Box>
                              <Typography variant='caption'>
                                Fecha de vencimiento revisión: &nbsp;
                                {this.state.data.prt.revision_fecha_vencimiento}
                              </Typography>
                            </Box>
                            <Box>
                              <Typography variant='caption'>
                                Planta revisión técnica: &nbsp;{this.state.data.prt.revision_direccion_prt + ', ' + this.state.data.prt.revision_comuna_prt}
                              </Typography>

                            </Box>
                          </Box>
                        }
                      </Box>
                    }
                  </CardContent>
                </Card>
              </Box>

              {
                /*****************************************
                  SOAP
                  ******************************************/
              }
              <Box mb={1}>
                <Card>
                  <CardContent>
                    <Box p={1}>
                      <Alert severity={this.state.data.estado_soap === 0 ? 'warning' :
                        this.state.data.estado_soap === 1 ? 'success' :
                          this.state.data.estado_soap === 2 ? 'error' :
                            this.state.data.estado_soap === 3 ? 'info' :
                              'info'}
                        style={{ minHeigth: '100px' }}>
                        <Typography variant='h6'>
                          Seguro Obligatorio
                        </Typography>
                        <Box>
                          {this.state.data.estado_soap === 0 ? <Box><strong>Estado sección: </strong> {' Pendiente a validación del Departamento de Tránsito Municipal.'}</Box> :
                            this.state.data.estado_soap === 1 ? <Box><strong>Estado sección: </strong> {' Todo en órden.'}</Box> :
                              this.state.data.estado_soap === 2 ? <Box><strong>Estado sección: </strong> {' Información rechazada.'}</Box> :
                                this.state.data.estado_soap === 3 ? <Box><strong>Estado sección: </strong> {' Información aún incompleta.'}</Box> :
                                  'info'}
                        </Box>
                        <Box>
                          <strong>Comentario al contribuyente</strong>: {this.state.data.comentario_soap}
                        </Box>

                        {/* { this.state.data.estado_soap===3 &&
                        <Box p={1}>
                          Sugerimos obtener tu Seguro Obligatorio en <a target='_blank' href="https://www.soapbomberos.cl">www.soapbomberos.cl</a>
                        </Box>
                        } */}
                      </Alert>
                    </Box>

                    {this.state.data.webservice_soap_status === false &&
                      [0, 2, 3].includes(this.state.data.estado_soap) && !this.state.data.bloqueado &&
                      this.state.data.soap &&
                      new Date(this.state.data.soap.created_at) < this.addHoursToDate(new Date(), -1) &&
                      <Box>
                        <Button startIcon={<CachedIcon />}
                          onClick={event => this.handleSubmit(event, { 'reload_soap': true })}
                        >
                          Recargar Seguro obligatorio
                        </Button>
                      </Box>
                    }

                    {/* CASO no es posible validar por webservice */}
                    {(!this.state.data.webservice_soap_status || this.state.data.sii_exigir_documentos) &&
                      <Box p={1} style={{ borderRadius: '5px', border: '2px solid #ddd', }}>
                        <Typography variant='overline' sx={{ fontWeight: 'bold' }}>
                          Comprobante de seguro obligatorio en PDF
                        </Typography>
                        <Box pl={2} sx={{ display: 'inline' }}>
                          <Chip size="small"
                            label={this.state.data.archivo_soap_status ? 'Completo' : 'Incompleto'}
                            icon={(this.state.data.archivo_soap_status) ? <DoneIcon /> : <WarningIcon />}
                            style={(this.state.data.archivo_soap_status) ? { backgroundColor: 'lightgreen' } : {}}
                          />
                        </Box>
                        {this.state.data.archivo_soap &&
                          <Box p={1} style={{ background: '#eeeeff', borderRadius: '5px' }}>
                            <Typography variant='caption'>
                              Actualmente ya tienes un archivo cargado&nbsp;
                            </Typography>
                            <Box>
                              <Button startIcon={<DownloadIcon />}
                                onClick={event => this.handleDownloadFile(event, this.state.data.archivo_soap)}
                                variant='contained'>
                                Descargar archivo
                              </Button>
                            </Box>
                          </Box>
                        }
                        {[0, 2, 3].includes(this.state.data.estado_soap) && !this.state.data.bloqueado &&
                          <Box p={1} mt={1} style={{ background: '#e1e1ff', borderRadius: '5px' }}>
                            <Typography variant='overline'>
                              Subir/Actualizar (Archivo PDF o imagen):&nbsp;
                            </Typography>
                            <Box>
                              <label htmlFor="encodedSoapFile">
                                <Input name="encodedSoapFile"
                                  id="encodedSoapFile"
                                  type="file"
                                  accept="image/*,.pdf"
                                  onChange={this.handleFile}
                                  style={{ display: 'none' }}
                                />
                                {'encodedSoapFile' in this.state.error && this.state.error.encodedSoapFile &&
                                  <Box sx={{ color: 'red' }}>El archivo debe ser un PDF o imágen</Box>
                                }
                                <Button startIcon={<UploadFileIcon />} variant='outlined' component="span">
                                  {this.state.data.encodedSoapFile !== '' && this.state.data.encodedSoapFile !== null ? 'Actualizar archivo' : 'Subir archivo'}
                                </Button>
                              </label>
                            </Box>
                          </Box>
                        }

                      </Box>
                    }

                    {/* CASO validación es por Webservice */}
                    {this.state.data.webservice_soap_status &&
                      <Box p={1}>
                        <Box>
                          <Typography variant='overline'>
                            Estado del Seguro obligatorio en línea
                          </Typography>
                          <Box pl={2} sx={{ display: 'inline' }}>
                            <Chip size="small"
                              label={this.state.data.webservice_soap_status ? 'Seguro obligatorio validado' : 'No fue posible validar el seguro obligatorio'}
                              icon={(this.state.data.webservice_soap_status) ? <DoneIcon /> : <WarningIcon />}
                              style={(this.state.data.webservice_soap_status) ? { backgroundColor: 'lightgreen' } : {}}
                            />
                          </Box>
                        </Box>
                        {this.state.data.soap &&
                          <Box>
                            <Box>
                              <Typography variant='caption'>
                                Fecha consulta: &nbsp;
                                {(new Date(this.state.data.soap.created_at)).toLocaleString('es-CL')}
                              </Typography>
                            </Box>
                            <Box>
                              <Typography variant='caption'>
                                Fecha de vencimiento seguro: &nbsp;
                                {this.state.data.soap.fecha_termino}
                              </Typography>
                            </Box>
                            <Box>
                              <Typography variant='caption'>
                                Empresa seguro: &nbsp;{this.state.data.soap.nombre_compania}
                              </Typography>

                            </Box>
                          </Box>
                        }
                      </Box>
                    }

                  </CardContent>
                </Card>
              </Box>


              {
                /*****************************************
                  Multas
                  ******************************************/
              }
              <Box mb={1}>
                <Card>
                  <CardContent>
                    <Box p={1}>
                      <Alert severity={this.state.data.estado_multas === 0 ? 'warning' :
                        this.state.data.estado_multas === 1 ? 'success' :
                          this.state.data.estado_multas === 2 ? 'error' :
                            this.state.data.estado_multas === 3 ? 'info' :
                              'info'}
                        style={{ minHeigth: '100px' }}>
                        <Typography variant='h6'>
                          Multas
                        </Typography>

                        <Box>
                          {this.state.data.estado_multas === 0 ? <Box><strong>Estado sección: </strong> {' Pendiente a validación del Departamento de Tránsito Municipal.'}</Box> :
                            this.state.data.estado_multas === 1 ? <Box><strong>Estado sección: </strong> {' Todo en órden.'}</Box> :
                              this.state.data.estado_multas === 2 ? <Box><strong>Estado sección: </strong> {' Información rechazada.'}</Box> :
                                this.state.data.estado_multas === 3 ? <Box><strong>Estado sección: </strong> {' Información aún incompleta.'}</Box> :
                                  'info'}
                        </Box>
                        <Box>
                          <strong>Comentario al contribuyente</strong>: {this.state.data.comentario_multas}
                        </Box>
                      </Alert>
                    </Box>

                    {this.state.data.multas && this.state.data.multas.length > 0 &&
                      <Box p={1}>
                        <Typography variant='overline' sx={{ fontWeight: 'Bold' }}>
                          {this.state.data.multas.length} multa{this.state.data.multas.length > 1 ? 's' : ''}
                        </Typography>
                        <TableContainer sx={{ border: 1, borderColor: 'divider', borderRadius: 1 }}>
                          <Table size='small'>
                            <TableHead>
                              <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                <TableCell padding='checkbox' />
                                <TableCell>#</TableCell>
                                <TableCell>Monto multa</TableCell>
                                <TableCell>Arancel</TableCell>
                                <TableCell>Comuna</TableCell>
                                <TableCell>Rol causa</TableCell>
                                <TableCell>Fecha infracción</TableCell>
                                <TableCell>Fecha sentencia</TableCell>
                                <TableCell>¿Ya la pagaste en otro lugar?</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {this.state.data.multas.slice(this.paginaMultas() * MULTAS_POR_PAGINA, (this.paginaMultas() + 1) * MULTAS_POR_PAGINA).map((object, i) => {
                                // índice en this.state.data.multas (los handlers lo usan)
                                const index = this.paginaMultas() * MULTAS_POR_PAGINA + i;
                                return (
                                  <React.Fragment key={object.multa_en_permiso_uuid}>
                                    <TableRow sx={object.ya_pagada ? { '& > td': { borderBottom: 0 } } : {}}>
                                      <TableCell padding='checkbox'>
                                        {object.ya_pagada &&
                                          <IconButton size='small'
                                            title={this.state.multas_abiertas[object.multa_en_permiso_uuid] ? 'Ocultar comprobante' : 'Ver comprobante'}
                                            onClick={() => this.setState(prevState => ({
                                              multas_abiertas: {
                                                ...prevState.multas_abiertas,
                                                [object.multa_en_permiso_uuid]: !prevState.multas_abiertas[object.multa_en_permiso_uuid]
                                              }
                                            }))}
                                          >
                                            {this.state.multas_abiertas[object.multa_en_permiso_uuid] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                          </IconButton>
                                        }
                                      </TableCell>
                                      <TableCell>{index + 1}</TableCell>
                                      <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                        {/* Formato chileno: miles con punto, decimales con coma; pesos sin decimales */}
                                        <NumberFormat displayType={'text'}
                                          value={Number(object.multa.monto)}
                                          thousandSeparator={'.'}
                                          decimalSeparator={','}
                                          decimalScale={object.multa.tipo_moneda === 1 ? 0 : 2}
                                          prefix={object.multa.tipo_moneda === 1 ? '$' : ''} />
                                        &nbsp;
                                        {object.multa.tipo_moneda === 2 ? 'UTM' : object.multa.tipo_moneda === 1 ? '' : 'UF'}
                                      </TableCell>
                                      <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                        <NumberFormat displayType={'text'}
                                          value={Number(object.multa.arancel)}
                                          thousandSeparator={'.'}
                                          decimalSeparator={','}
                                          decimalScale={0}
                                          prefix={'$'} />
                                      </TableCell>
                                      <TableCell>{object.multa.comuna}</TableCell>
                                      <TableCell>{object.multa.rol_causa}</TableCell>
                                      <TableCell>{(new Date(object.multa.fecha_infraccion)).toLocaleDateString('es-CL')}</TableCell>
                                      <TableCell>{(new Date(object.multa.fecha_sentencia)).toLocaleDateString('es-CL')}</TableCell>
                                      <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                        {!this.state.data.bloqueado && this.state.data.multas[index].ya_pagada_validacion !== 1 ?
                                          <RadioGroup row
                                            name="ya_pagada"
                                            id={object.multa_en_permiso_uuid}
                                            value={this.state.data.multas[index].ya_pagada}
                                            onChange={(event) => this.handleSwitchMultaChange2(event, index)}
                                          >
                                            <FormControlLabel
                                              value={false} control={<Radio size='small' id={object.multa_en_permiso_uuid} />} label="No" />
                                            <FormControlLabel
                                              value={true} control={<Radio size='small' id={object.multa_en_permiso_uuid} />} label="Sí" />
                                          </RadioGroup>
                                          :
                                          (object.ya_pagada ? 'Sí' : 'No')
                                        }
                                      </TableCell>
                                    </TableRow>
                                    {object.ya_pagada &&
                                      <TableRow>
                                        <TableCell colSpan={9} sx={{ py: 0 }}>
                                          <Collapse in={!!this.state.multas_abiertas[object.multa_en_permiso_uuid]} timeout='auto' unmountOnExit>
                                            <Box py={1}>
                                          {object.ya_pagada && !object.ya_pagada_justificacion &&
                                            <Alert severity='info'>
                                              Por favor adjunta un comprobante del pago antes de proceder
                                            </Alert>
                                          }
                                          {object.ya_pagada &&
                                            <Box>
                                              <Alert severity={this.state.data.multas[index].ya_pagada_justificacion === null ? 'info' :
                                                this.state.data.multas[index].ya_pagada_validacion === 0 ? 'warning' :
                                                  this.state.data.multas[index].ya_pagada_validacion === 1 ? 'success' :
                                                    this.state.data.multas[index].ya_pagada_validacion === 2 ? 'error' :
                                                      'info'}
                                                style={{ minHeigth: '100px' }}>
                                                <Box>
                                                  {this.state.data.multas[index].ya_pagada_justificacion === null ? <Box><strong>Estado multa: </strong> {' Información aún incompleta.'}</Box> :
                                                    this.state.data.multas[index].ya_pagada_validacion === 0 ? <Box><strong>Estado multa: </strong> {' Pendiente a validación del Departamento de Tránsito Municipal.'}</Box> :
                                                      this.state.data.multas[index].ya_pagada_validacion === 1 ? <Box><strong>Estado multa: </strong> {' Todo en órden.'}</Box> :
                                                        this.state.data.multas[index].ya_pagada_validacion === 2 ? <Box><strong>Estado multa: </strong> {' Información rechazada.'}</Box> :
                                                          'info'}
                                                </Box>
                                              </Alert>
                                              {object.ya_pagada_justificacion &&
                                                <Box p={1} style={{ background: '#eeeeff', borderRadius: '5px' }}>
                                                  <Typography variant='overline'>
                                                    Actualmente ya tienes un archivo cargado&nbsp;
                                                  </Typography>
                                                  <Button startIcon={<DownloadIcon />} onClick={event => this.handleDownloadFile(event, object.ya_pagada_justificacion)}>
                                                    Descargar archivo
                                                  </Button>
                                                </Box>
                                              }
                                              {(this.state.data.multas[index].ya_pagada_validacion) !== 1 && !this.state.data.bloqueado &&
                                                <Box p={1} mt={1} style={{ background: '#e1e1ff', borderRadius: '5px' }}>
                                                  <Typography variant='overline'>
                                                    Subir/Actualizar comprobante de pago (Archivo PDF o imagen):&nbsp;
                                                  </Typography>
                                                  <Box>
                                                    <Box>
                                                      <Typography variant='overline' sx={{ fontWeight: 'Bold' }}>
                                                        Subir uno nuevo archivo:&nbsp;
                                                      </Typography>
                                                      <input name="encodedMultaFile"
                                                        id={object.multa_en_permiso_uuid}
                                                        className='form-control'
                                                        type="file"
                                                        accept="image/*,.pdf"
                                                        onChange={this.handleMultaFile} />
                                                      {'encodedMultaFile' + '_' + object.multa_en_permiso_uuid in this.state.error &&
                                                        this.state.error['encodedMultaFile' + '_' + object.multa_en_permiso_uuid] &&
                                                        <Box sx={{ color: 'red' }}>El archivo debe ser un PDF o imágen</Box>
                                                      }
                                                    </Box>
                                                  </Box>
                                                </Box>
                                              }

                                            </Box>
                                          }
                                            </Box>
                                          </Collapse>
                                        </TableCell>
                                      </TableRow>
                                    }
                                  </React.Fragment>
                                )
                              })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                        {this.state.data.multas.length > MULTAS_POR_PAGINA &&
                          <TablePagination component='div'
                            count={this.state.data.multas.length}
                            page={this.paginaMultas()}
                            rowsPerPage={MULTAS_POR_PAGINA}
                            rowsPerPageOptions={[]}
                            onPageChange={(event, pagina) => this.setState({ multas_pagina: pagina })}
                            labelDisplayedRows={({ from, to, count }) => from + '–' + to + ' de ' + count + ' multas'}
                          />
                        }
                      </Box>

                    }


                  </CardContent>
                </Card>
              </Box>
              {
                /*****************************************
                  Estado Consolidado
                ******************************************/
              }
              <Box mb={1} pb={2}>
                <Box p={0}>
                  <Alert severity={this.state.data.estado_consolidado === 0 ? 'warning' :
                    this.state.data.estado_consolidado === 1 ? 'success' :
                      this.state.data.estado_consolidado === 2 ? 'error' :
                        this.state.data.estado_consolidado === 3 ? 'info' :
                          this.state.data.estado_consolidado === 4 ? 'success' :
                              this.state.data.estado_consolidado === 6 ? 'warning' :
                            'info'}
                    style={{ minHeigth: '100px' }}
                    variant={[4, 5, 6].includes(this.state.data.estado_consolidado) ? 'filled' : 'standard'}>
                    <Typography variant='h6'>
                      Estado final del Permiso de circulación
                    </Typography>
                    <Box>
                      <strong>Estado consolidado: </strong> {this.state.data.estado}
                    </Box>
                    <Box>
                      <strong>Comentario al contribuyente</strong>: {this.state.data.comentario_consolidado}
                    </Box>
                  </Alert>
                </Box>
                <Box>

                  {[1, 6].includes(this.state.data.estado_consolidado) &&
                    <Box p={3}>
                      <Button variant='contained'
                        color='primary'
                        component={Link}
                        to={{ pathname: 'http://pago.smc.cl/pagoPCVv2/muni/renca.aspx' }} target="_blank">
                        Ir al Pago
                      </Button>
                    </Box>
                  }
                  {this.state.data.estado_consolidado === 0 && !this.state.data.bloqueado && !this.faltanDatosContribuyente() &&
                    <Box p={3}>
                      <Button variant='contained'
                        id='boton_solicitar_revision_2'
                        color='primary'
                        onClick={this.handleBloquear}>
                        Solicitar revisión de los documentos (Esto bloqueará este formulario, todo mientras sea revisado por nuestros agentes.)
                      </Button>
                    </Box>
                  }
                  {this.state.data.bloqueado && [0, 2, 3].includes(this.state.data.estado_consolidado) &&
                    <Box p={3}>
                      <Typography variant='overline'>
                        Tu permiso ahora está siendo validado por nuestros equipos. Te notificaremos por mail cuando todo esté listo.
                      </Typography>
                    </Box>
                  }
                </Box>

              </Box>
              </>
              }



            </Box>
          }
        </Box>
      </PublicLayout>
    );
  }
}

export default withRouter(PermisoPublico);
